(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-snooker/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-snooker/assets/javascripts/status.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_snooker = svs.themes.sport_snooker || {};
  var logger = new svs.core.log.Logger('svs.themes.sport_snooker');

  svs.themes.sport_snooker.matchNotice = function (match) {
    if (!match) {
      logger.warn('Invalid parameter to matchNotice, returning empty string.');
      return '';
    }

    var matchStatus;

    switch (match.status) {
      case 24:
        matchStatus = 'Försenad matchstart';
        break;

      case 26:
        matchStatus = 'Avbruten';
        break;

      case 28:
        matchStatus = 'Stoppad av domare';
        break;

      case 29:
      case 116:
      case 117:
        matchStatus = 'Walkover';
        break;

      case 30:
      case 118:
      case 119:
        matchStatus = 'Deltagare bröt';
        break;

      default:
        matchStatus = '';
        break;
    }

    return matchStatus;
  };

  svs.themes.sport_snooker.isLive = function (status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    if (status > 64 && status < 102 || status === 14) {
      return true;
    }

    return false;
  };

  svs.themes.sport_snooker.isFinished = function (status) {
    var s = status;

    if (s === 31) {
      return true;
    }

    return false;
  };

  svs.themes.sport_snooker.isEnded = function (status) {
    if (status === 25 || status === 26 || status === 28 || status === 29 || status === 31 || status > 115 && status < 122) {
      return true;
    }

    return false;
  }; 


  svs.themes.sport_snooker.subscribeMatch = function (params) {
    if (svs.themes.isDateHoursDiff(params.time, -4) && !svs.themes.sport_snooker.isEnded(params.status)) {
      return true;
    }

    return false;
  };

  svs.themes.sport_snooker.hasStarted = function (status) {
    return status > 0 && status !== 24;
  };


  svs.themes.sport_snooker.isFullTimeOrPassed = function (status, options) {
    options = _.extend({
      includeFullTime: true,
      includePauses: true,
      includeFinished: true
    }, options);
    var statusesForOvertime = [];

    if (options.includeFullTime) {
      statusesForOvertime.push(31);
    }

    if (options.includePauses) {
      statusesForOvertime.push(14);
    }

    return _.contains(statusesForOvertime, status);
  };


  svs.themes.sport_snooker.getStatusText = function (options) {
    var text = '';
    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      getStartTime: true
    });
    var status = options.statusId;

    if (svs.themes.sport_snooker.isLive(status)) {
      if (status > 64 && status < 102) {
        text = "FRA ".concat(status - 64);
      } else if (status === 14) {
        text = 'PAUS';
      }
    } else if (svs.themes.sport_snooker.isEnded(status)) {
      if (status === 25) {
        text = 'INST';
      } else if (status === 28) {
        text = 'UPPH';
      } else if (status === 29 || status === 116 || status === 117 || status === 120 || status === 121) {
        text = 'SLUT';
      } else if (status === 26 || status === 30 || status === 118 || status === 119) {
        text = 'AVBR';
      } else {
        text = 'SLUT';
      }
    } else if (options.startTime && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    }

    return text;
  };
})(svs);
 })(window);